import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    maxWidth: 840,
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(4),
    },
  },
}));
